import { TextField, TextFieldProps } from '@material-ui/core';

export default function TextInput({
    label,
    id = 'textinput',
    variant = 'filled',
    inputProps = {},
    'aria-required': ariaRequired,
    ...rest
}: TextFieldProps) {
    return (
        <TextField
            id={id}
            label={label}
            variant={variant}
            inputProps={{
                ...inputProps,
                'aria-required': ariaRequired
            }}
            {...rest}
            autoComplete={'off'}
        />
    );
}
